import * as React from "react";
import { connect } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import {
  updateCurrentExercise,
  UpdateCurrentExercise,
  updateCurrentWorkout,
  UpdateCurrentWorkout,
  clearCurrentWorkout,
  createWorkout,
  CreateWorkout
} from "../../resources/user/user.actions";
import { getCurrentWorkout } from "../../resources/user/user.selectors";
import { IStore } from "../../resources/types";
import { IWorkout, IExercise } from "../../resources/user/types";
import Button from "../../components/button";
import EditExercise from "../exercises/exercise/edit";
import Note from "../exercises/note";

interface IProps {
  workout: IWorkout | undefined;
  createWorkout: CreateWorkout;
  updateCurrentWorkout: UpdateCurrentWorkout;
  updateCurrentExercise: UpdateCurrentExercise;
  clearCurrentWorkout: () => void;
}

function Exercises({
  workout,
  createWorkout,
  updateCurrentWorkout,
  updateCurrentExercise,
  clearCurrentWorkout
}: IProps) {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const onSubmitExercise = (
    exerciseId: string,
    newValues: Partial<IExercise>
  ) => updateCurrentExercise(exerciseId, newValues);
  const onSubmitNote = (note: string) => updateCurrentWorkout({ note });

  if (!workout) {
    return null;
  }

  const onCreateWorkout = async () => {
    await createWorkout(id, workout);
    clearCurrentWorkout();
    history.push(`/users/${id}`);
  };

  return (
    <>
      {(workout.exercises || []).map(exercises => (
        <EditExercise
          key={exercises.id}
          exercise={exercises}
          onSubmit={onSubmitExercise}
        />
      ))}
      <Note onSubmit={onSubmitNote} workout={workout} />
      <Button onClick={onCreateWorkout}>Create Workout</Button>
    </>
  );
}
export default connect(
  (state: IStore) => ({
    workout: getCurrentWorkout(state)
  }),
  {
    createWorkout,
    updateCurrentWorkout,
    updateCurrentExercise,
    clearCurrentWorkout
  }
)(Exercises);
